import type { ResolvedProductWrapper } from "@/components/custom/ProductBuilder/ProductBuilderContext";
import { getEntry } from "@/lib/contentful/guards";
import type { TypeProductBuilder } from "@/types/contentful/generated";
import { stripZeroWidth } from "@/utils/ContentfulHelper";

type ProductWrapperRefs = TypeProductBuilder<undefined, string>["fields"]["productWrappers"];

export function resolveProductWrappers(refs: ProductWrapperRefs | undefined): ResolvedProductWrapper[] {
  return (refs ?? []).flatMap(ref => {
    const wrapper = getEntry(ref);
    const product = getEntry(wrapper?.fields.product);
    return wrapper && product
      ? [{ product: { ...product.fields, sku: stripZeroWidth(product.fields.sku) }, productWrapper: wrapper.fields }]
      : [];
  });
}
